<script>
  import Row from './row.svelte'
  import Block from './block.svelte'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  export let on = false
  export let onColor = 'DodgerBlue'
  export let offColor = 'lightgrey'

  export let height = '1.1rem'
  export let width = '2.2rem'
</script>


<Block 
  backgroundColor={on?onColor:offColor} borderRadius={height} {height} {width}
  cursor=pointer padding=2
  on:click={()=>{on=!on;dispatch('change', {on:on})}}
>
  <Row width=100% height=100% align={on?'flex-end':'flex-start'}>
    <Block borderRadius=50% backgroundColor=white height=100% aspectRatio='1/1'></Block>
  </Row>
</Block>
